import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { OverTimeCategoryDto } from "./over-time-category.dto";

export class OverTimeCategoryResponse extends GlobalResponseObject{
    data?: OverTimeCategoryDto;

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: OverTimeCategoryDto){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}